import { cacheName, cache } from '@/utils/cacheManager'
import lang from '@/lang'
import { Message } from '@/utils/Message'
import { MessageBox } from 'element-ui'
import { Company } from '@/class/model/mdm/Company'
import { getTitleByCmpIdxList } from '@/api/partner/title'
import { getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { mergeArray } from '@/utils/commonUtil'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { CHARGE_SOURCE_SPLIT } from '@/class/cargo/model/parameters/SystemConstants'

export class SEUtils {
  /**
   * 根据系统跳转规则改变委托件、毛、体与实际件、毛、体的跳转逻辑
   * 0: 不影响
   * 1: 委托跳实际，实际不跳委托
   * 2: 双向跳转
   */
  static async changeQWCRule(contractChange, actualChange) {
    await cache.load(cacheName.CONFIG)
    const rule = Number(cache.config.get('SEQuantityWeightCubageRule'))
    let funcResult = null
    if (rule === 1) {
      if (typeof contractChange === 'function') {
        funcResult = contractChange()
      }
    } else if (rule === 2) {
      if (typeof contractChange === 'function') {
        funcResult = contractChange()
      } else if (typeof actualChange === 'function') {
        funcResult = actualChange()
      }
    }
    if (funcResult instanceof Promise) {
      await funcResult
    }
  }
  /**
   * 根据部门ID获取部门
   */
  static getDepartmentById(departmentId) {
    // var department = null
    // for(var dep in Session.getInstance().departments)
    // {
    //   if (dep.departmentId == departmentId) {
    //     department = dep
    //     break
    //   }
    // }
    // return department
  }
  /**
   * 上次的ID
   */
  static preSelectedId = 0
  static preJob
  /**
   * 当前的ID
   */
  static newSelectedId = 0
  /**
   * 更新客户，订舱代理，报关行时刷新费用相关的结算单位。
   *
   * @param job
   * @param accountId
   * @param typeLabel
   */
  static refreshChargeAccountId(job, field, typeLabel, modifiedData, refreshChargeCallback) {
    let chargeFlag = false
    let readonlyFlag = false
    if (!job.charges || job.charges.length <= 0) return
    if (field === 'customerId' && job[field] === 0) {
      job[field] = job['preCustomerId']
    }
    if ((job.lob === 'SE' || job.lob === 'AE') && field === 'bookingAgent' && job[field] === 0) {
      job[field] = job['preBookingAgent']
    }
    for (const item of job.charges) {
      if (item.accountId > 0 && item.accountId === job[field] && Number(item.offsetState) === 0 && !item.diffChargeUuid && item.chargeSource !== CHARGE_SOURCE_SPLIT.code) {
        chargeFlag = true
        if (item.verifiedAmount !== 0 || item.billingUuid || item.billingPaymentUuid || item.invoiceUuid || item.confirmBillUuid || item.shared) {
          readonlyFlag = true
        }
      }
    }
    if (chargeFlag) {
      if (readonlyFlag) {
        MessageBox.confirm(typeLabel + lang.t('CargoMsg.Cargo_CanNotChargeTips'), lang.t('common.tips.prompt'), {
          confirmButtonText: lang.t('common.btn.ok'),
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
          type: 'info'
        })
        return false
      } else {
        this.preSelectedId = job[field]
        this.preJob = job
        MessageBox.confirm(typeLabel + lang.t('CargoMsg.Cargo_RefreshChargeTips'), lang.t('common.tips.prompt'), {
          confirmButtonText: lang.t('constant.yes'),
          cancelButtonText: lang.t('constant.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          this.newSelectedId = job[field] // 当前
          if (!this.newSelectedId || this.newSelectedId <= 0) return

          let invoiceTitle = await Company.getCompanyName(this.newSelectedId)
          const compKeys = [this.newSelectedId]
          if (compKeys.length > 0) {
            // 根据结算对象从数据库中取默认开票抬头
            const titles = await getTitleByCmpIdxList(compKeys).then(res => {
              return res.data
            })
            if (titles && titles.length > 0 && titles[0].title) {
              invoiceTitle = titles[0].title
            }
          }
          if (!this.preJob.charges || this.preJob.charges.length <= 0) return
          await cache.load(cacheName.CONFIG)
          const arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
          const companyFactorySigns = await ChargeUtils.getCompanyFactorySign(job.customerId)
          let isFlag = false
          const charges = []
          const customerSettlementAgentMap = {}
          for (const item of this.preJob.charges) {
            if (arSettlementUnitOptional && item.receivable && field === 'customerId') {
              // 开启工厂参数时，旧的结算单位不属于当前委托单位工厂的，直接清空
              if (!(Number(item.verifiedAmount) !== 0 || item.billingUuid || item.billingPaymentUuid || item.invoiceUuid || item.confirmBillUuid || item.shared || item.diffChargeUuid || item.chargeSource === CHARGE_SOURCE_SPLIT.code)) {
                this.getInvoiceTitleData(companyFactorySigns, item, invoiceTitle)
                // CARGO-41628，复制业务新建的时候，费用同时复制，但在系统提示更改订舱代理，刷新费用的时候，国内国外的没有随订舱代理做变更
                if (job.lob === 'SE' || job.lob === 'AE') {
                  // 这里只有委托单位
                  await ChargeUtils.getChargeOverseaByConfig(item)
                }
                await this.getSettlementByCompanyId(item, customerSettlementAgentMap)
                charges.push(item)
                if (!isFlag) isFlag = true
              }
            } else {
              if (Number(item.accountId) === Number(this.preSelectedId)) {
                if (!(Number(item.verifiedAmount) !== 0 || item.billingUuid || item.billingPaymentUuid || item.invoiceUuid || item.confirmBillUuid || item.shared || item.diffChargeUuid || item.chargeSource === CHARGE_SOURCE_SPLIT.code)) {
                  if (arSettlementUnitOptional && item.receivable && field !== 'customerId') {
                    this.getInvoiceTitleData(companyFactorySigns, item, invoiceTitle)
                  } else {
                    item.accountId = this.newSelectedId
                    item.invoiceTitle = invoiceTitle
                  }
                  // CARGO-41628，复制业务新建的时候，费用同时复制，但在系统提示更改订舱代理，刷新费用的时候，国内国外的没有随订舱代理做变更
                  if ((job.lob === 'SE' || job.lob === 'AE') && (field === 'bookingAgent' || field === 'customerId')) {
                    await ChargeUtils.getChargeOverseaByConfig(item)
                  }
                  await this.getSettlementByCompanyId(item, customerSettlementAgentMap)
                  charges.push(item)
                  if (!isFlag) isFlag = true
                }
              }
            }
          }
          if (isFlag && charges.length > 0) {
            if (job.uuid) {
              modifiedData.charges = modifiedData.charges || []
              mergeArray(modifiedData.charges, charges) // 只记住修改过的数据
            }
            if (typeof refreshChargeCallback === 'function') {
              refreshChargeCallback()
            }
          }
        })
      }
    }
    return true
  }
  static getInvoiceTitleData(companyFactorySigns, item, invoiceTitle) {
    const has = ChargeUtils.checkFactorySign(companyFactorySigns, Number(this.newSelectedId))
    if (!has) {
      item.accountId = 0
      item.invoiceTitle = ''
    } else {
      item.accountId = this.newSelectedId
      item.invoiceTitle = invoiceTitle
    }
  }
  // 根据结算对象，获取结算代理
  static async getSettlementByCompanyId(charge, customerSettlementAgentMap) {
    const accountId = charge.accountId
    if (!accountId || accountId <= 0) return
    const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
    const staticOptions = customerSettlementAgentMap[accountId]
    if (staticOptions && staticOptions.length > 0) {
      charge.settlementAgentId = staticOptions[0].cmpIdx
    } else {
      const res = await getSettlementAgentsByCmpIdx(accountId)
      let dbSettlementAgents = res.data
      if (!dbSettlementAgents) {
        dbSettlementAgents = []
        dbSettlementAgents.push(chargeAccount)
      }
      if (dbSettlementAgents && dbSettlementAgents.length > 0) {
        charge.settlementAgentId = dbSettlementAgents[0].cmpIdx
        customerSettlementAgentMap[accountId] = dbSettlementAgents
      }
    }
  }
  // /**
  //  * 加载客户信息
  //  */
  // static loadCustomerDetail2Handler(evt = null) {
  //   var company: Company = Company.getCompanyById(newSelectedId)
  //   if (company.customerDetail && company.customerDetail.needLoadTitle()) {
  //     company.customerDetail.loadTitle2(loadTitle2, faultHandler)
  //   }
  //   else {
  //     loadTitle2()
  //   }
  // }
  // /**
  //  * 刷新开票抬头
  //  */
  // static loadTitle2(evt = null) {
  //   var invoiceTitle: String = null
  //   var company: Company = Company.getCompanyById(newSelectedId)
  //   if (company) {
  //     if (ResourceManager.getInstance().localeChain[0] == "zh_CN") {
  //       invoiceTitle = company.chineseName
  //     } else {
  //       invoiceTitle = company.englishName
  //     }
  //   }
  //   if (company.customerDetail && company.customerDetail.title) {
  //     var titles: IList = company.customerDetail.title
  //     for(var t: Title in titles)
  //     {
  //       if (t.isDefaultTitle) {
  //         invoiceTitle = t.title
  //         break
  //       }
  //     }
  //   }
  //   for(var item: Charge in preJob.charges)
  //   {
  //     if (item.accountId == preSelectedId) {
  //       if (!(item.verifiedAmount != 0 || item.billing != null || item.billPayment != null || item.invoice != null || item.confirmBill != null || item.isShared)) {
  //         item.accountId = newSelectedId
  //         item.invoiceTitle = invoiceTitle
  //       }
  //     }
  //   }
  // }
  /**
   * load fault
   */
  static faultHandler(evt) {
    // MessageDialog.showFault(evt)
  }
  static needTip(job, measure) {
    if (job.jobState === 0 && job.charges) {
      const index = job.charges.findIndex(p => p.measure === measure &&
          p.chargeState !== 1 && SEUtils.checkAdjust(p))
      if (index > -1) {
        return true
      }
    }
    return false
  }
  static needTip2(job, measure) {
    if (job.jobState === 0 && job.charges) {
      const index = job.charges.findIndex(p => p.measure === measure &&
          p.chargeState !== 1 && SEUtils.checkAdjust(p) && p.quantity !== SEUtils.getQuantity(job))
      if (index > -1) {
        return true
      }
    }
    return false
  }
  static checkAdjust(item) {
    if (!item) {
      return false
    }
    if (item.chargeState === 1) {
      return false
    }
    if (Number(item.verifiedAmount) !== 0 || item.billingUuid || item.billingPaymentUuid ||
        item.invoiceUuid || item.shared || item.collection || item.apportioned ||
        item.adjustment || item.relatedMbl) {
      return false
    }
    return true
  }
  static getQuantity(job) {
    let quantity = 0
    if (job.manifestInfos) {
      const soNoMap = {}
      for (const man of job.manifestInfos) {
        if (man.manifestGoods) {
          for (const goods of man.manifestGoods) {
            if (goods.soNo && !goods.deleted && !soNoMap[goods.soNo]) {
              soNoMap[goods.soNo] = true
              quantity += 1
            }
          }
        }
      }
    }
    if (quantity === 0) {
      quantity = 1
    }
    return quantity
  }
}
